$(document).ready(() => {
  $('.fade-in-text').observe(
    (evt) => {
      const el = evt[0].target;
      if (evt[0].isIntersecting) {
        el.style.opacity = 1;
        el.style.transform = 'translateY(0)';
      }
    },
    { threshold: 1 }
  );
});
